import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { Order } from '../../interfaces/order';
import { UserService } from '../../services/user.service';
import { Utility } from '../../utility';
import { ItonicsAuthService } from '../../services/itonicsAuth.service';
import { SettingService } from '../../services/setting.service';
import { Subscription } from 'rxjs';
import { Settings } from '../../interfaces/setting';

@Component({
  selector: 'app-orderlst',
  templateUrl: './orderlst.component.html',
  styleUrls: ['./orderlst.component.scss']
})
export class OrderlstComponent implements OnInit {
  public netToken = 0;

  public extraTotal = 0;
  settingSubscrition: Subscription;
  public settingsData: any = [];

  public myOrderItems: Order[] = [];
  public orderList: any = [];
  public myOrderItemsList: any = [];

  public userDate: any = '';

  public counterValue = 1;

  public loggedId;

  constructor(private orderService: OrderService, private _userService: UserService, public _itonicsAuthService: ItonicsAuthService, private settingService: SettingService,) {
  }

  ngOnInit() {
    this.getMyOrder();
  }

  getMyOrder() {
    this.loggedId = this._itonicsAuthService.getCurrentUser()['username'];

    let settingdata;
    this.settingSubscrition = this.settingService.settings.subscribe((settings: Settings) => {
      settingdata = settings;
      if (settingdata.length == 0) {
        // console.log('no data')
        return
      }
      settingdata.forEach(element => {
        this.settingsData[element.alias] = element.value;
      });

    this.orderService.getOrdersByUserId(this.loggedId).subscribe((myorder) => {
      const reformattedArray = myorder.map((obj) => {
        const newObject: any = Object.assign({}, obj);

        newObject['date'] = Utility.convert(obj['date']);
        newObject.net = Math.round(obj['menuItem']['price'] * obj['quantity']);
        newObject.total = Math.round(obj.quantity * obj['menuItem'].price - obj.quantity * obj['menuItem'].price * 0.87 * (this.settingsData.discount / 100));

        /*if (newObject.total > this.settingsData.lunchamount) {
          newObject.extra = newObject.total - this.settingsData.lunchamount;
          this.extraTotal += newObject.extra;
        } else {
          newObject.extra = '0';
        }*/

        this.netToken += newObject.net;

        // if (this.userDate !== obj['date']) {
        // this.userDate = obj['date'];
        // console.log(this.counterValue++)
        newObject.indexId = this.counterValue++;
        newObject['date'] = Utility.convert(obj['date']);
        /*} else {
          newObject.indexId = '';
          newObject['date'] = '';
        }*/

        return newObject;
      });

      this.myOrderItems = reformattedArray;

      this.myOrderItemsList = this.myOrderItems.reduce((p, n) => {
        if (!p[n.date]) {
          p[n.date] = [];
        }
        p[n.date].push(n);
        return p;
      }, {});

      console.log(this.myOrderItemsList);

      this.orderList = [];
      Object.keys(this.myOrderItemsList).forEach((key) => {
        const tempObj = [];
        let total = 0;
        tempObj['data'] = this.myOrderItemsList[key];
        tempObj['date'] = key;
        this.myOrderItemsList[key].forEach((value) => {
          total += value.total;
        });
        // test['extra'] = total;

        if (total > this.settingsData.lunchamount) {
          tempObj['extra'] = total - this.settingsData.lunchamount;
          this.extraTotal += tempObj['extra'];
        } else {
          tempObj['extra'] = '0';
        }

        // this.netToken += total;


        this.orderList.push(tempObj);
      });

      //      this.orderList.sort((a, b) => a.date - b.date);
    });
    })

  }
  printOrders() {
    let printContents, popupWin, title;
    title = 'Users Order';
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <style>
          td{
                border-bottom: 1px solid #353535;
                border-right: 1px solid #353535;
          }
          .hide-print{
          display: none;
          }
          .menu-title span{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 200px;
            display: inline-block;
          }
           table th,
           table td{
          font-size: 10px;
          }
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    // popupWin.document.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/orderlst/orderlst.component.ts